module.exports = "/virtual-football-league/img/video/clubs/germany/bayern.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/germany/bayern.png
// module id = 343
// module chunks = 4